module.exports = __webpack_public_path__ + "img/6_hills.1f994234.jpg";